import { useLocationStore } from '@shared/global-store/stores/location/location'

export const generateState = (): string => {
  const timestamp = Date.now().toString()
  const randomString = Math.random().toString(36).substring(2)
  return timestamp + randomString
}

export const generateNonce = (length: number): string => {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let nonce = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    nonce += characters.charAt(randomIndex)
  }

  return nonce
}

export const getNonce = (token: string) => {
  return decodeJwt(token).payload.nonce
}

export const decodeJwt = (token: string) => {
  const [header, payload, signature] = token.split('.')

  const decodedHeader = JSON.parse(atob(header))
  const decodedPayload = JSON.parse(atob(payload))

  return {
    header: decodedHeader,
    payload: decodedPayload,
    signature,
  }
}

export const oauthAuthorizationRedirect = () => {
  try {
    const clientId = process.env.OAUTH2_CLIENT_ID
    const authorizationUri = import.meta.env.PUBLIC_OAUTH2_AUTHORIZATION_URL

    const { locale } = useLocationStore()

    const redirectUri = import.meta.env.PUBLIC_OAUTH2_REDIRECT_URI

    if (!clientId || !authorizationUri || !redirectUri) {
      return ''
    }

    const authorizationRequestUrl = new URL(authorizationUri)

    authorizationRequestUrl.searchParams.append(
      'scope',
      'openid email customer-account-api:full'
    )
    authorizationRequestUrl.searchParams.append('client_id', clientId)
    authorizationRequestUrl.searchParams.append('response_type', 'code')
    authorizationRequestUrl.searchParams.append('locale', locale || 'en')
    authorizationRequestUrl.searchParams.append('redirect_uri', redirectUri)
    authorizationRequestUrl.searchParams.append('state', generateState())
    authorizationRequestUrl.searchParams.append('nonce', generateNonce(20))

    return authorizationRequestUrl.toString()
  } catch {
    return ''
  }
}

export const oauthLogoutRedirect = (token: string) => {
  const logoutRequestUri = import.meta.env.PUBLIC_OAUTH2_LOGOUT_URL

  const postLogoutRedirectUri = import.meta.env
    .PUBLIC_OAUTH2_POST_LOGOUT_REDIRECT_URI

  if (!logoutRequestUri || !postLogoutRedirectUri) {
    throw new Error('OAuth2 logout environment variables are not set')
  }

  const logoutRequestUrl = new URL(logoutRequestUri)
  logoutRequestUrl.searchParams.append('id_token_hint', token)
  logoutRequestUrl.searchParams.append(
    'post_logout_redirect_uri',
    postLogoutRedirectUri
  )

  return logoutRequestUrl.toString()
}

export const getLogoutUrl = () => {
  return '/api/auth/logout'
}
